<script setup>
import FabricWiseReport from './fabric-wise-report.vue'

definePage({
  meta: {
    subject: 'Fabric Wise Report',
  },
})
</script>

<template>
  <FabricWiseReport />
</template>
